import { ArrowIcon, CloseIcon, ScaleIcon } from "../../assets/icons";
import { Image } from "../image/image";
import { useEffect, useMemo, useState } from "react";
import classNames from "classnames";

import styles from "./mediaSlider.module.css";
import { Video } from "../video/video";
import { ZoomableImage } from "../zoomableImage/zoomableImage";

export const MediaSlider = ({ media, images, videoPreviewOnly = false, aspect = "1.5", className, ...props }) => {
    const [current, setCurrent] = useState(0);
    const [bigPicture, setBigPicture] = useState(false);

    const resolvedMedia = useMemo(() => {
        if (media && Array.isArray(media)) return media;
        if (images && Array.isArray(images)) return images.map(src => ({ type: "image", src }));
        return [];
    }, [media, images]);

    const imageItems = useMemo(() => resolvedMedia.filter(el => el.type === "image"), [resolvedMedia]);
    const [imagesCurrent, setImagesCurrent] = useState(0);

    const slideWidth = useMemo(() => {
        if (!resolvedMedia || resolvedMedia.length === 0) return "100%";
        return `${100 / resolvedMedia.length}%`;
    }, [resolvedMedia]);

    useEffect(() => setCurrent(0), [resolvedMedia]);
    useEffect(() => setImagesCurrent(0), [resolvedMedia]);

    return (
        <div className={classNames(styles.image_slider, className)} style={{ aspectRatio: aspect }} {...props}>
            {
                resolvedMedia && resolvedMedia.length > 1 &&
                <>
                    <button className={styles.back_arrow} disabled={current <= 0} onClick={() => setCurrent(prev => prev - 1)}>
                        <ArrowIcon angle={180} />
                    </button>
                    <button className={styles.front_arrow} disabled={current >= resolvedMedia.length - 1} onClick={() => setCurrent(prev => prev + 1)}>
                        <ArrowIcon />
                    </button>
                </>
            }
            <div className={classNames(styles.big_picture, { [styles.active]: bigPicture })}>
                {
                    resolvedMedia && resolvedMedia.length > 1 &&
                    <>
                        <button className={styles.back_arrow_big_picture} disabled={imagesCurrent <= 0} onClick={() => setImagesCurrent(prev => prev - 1)}>
                            <ArrowIcon angle={180} />
                        </button>
                        <button className={styles.front_arrow_big_picture} disabled={imagesCurrent >= imageItems.length - 1} onClick={() => setImagesCurrent(prev => prev + 1)}>
                            <ArrowIcon />
                        </button>
                    </>
                }
                <button className={styles.close_icon} onClick={() => setBigPicture(false)}>
                    <CloseIcon />
                </button>
                {
                    imageItems.length > 0 &&
                    <>
                        <ZoomableImage
                            key={imageItems[imagesCurrent].src}
                            src={imageItems[imagesCurrent].src}
                        />
                    </>
                }
            </div>
            <div className={styles.images} style={{ width: `${resolvedMedia.length * 100}%`, left: `-${current * 100}%` }}>
                {
                    resolvedMedia.map((file, i) => {
                        if (file.type === "image") {
                            return <Image key={i} width={slideWidth} objectFit="cover" src={file.src} className={styles.image} onClick={() => {
                                setImagesCurrent(imageItems.findIndex(el => el === file));
                                setBigPicture(true);
                            }} />;
                        } else {
                            return <Video key={i} width={slideWidth} objectFit="cover" src={file.src} className={styles.image} previewOnly={videoPreviewOnly} />;
                        }
                    })
                }
            </div>
            <ScaleIcon className={classNames(styles.scale, { [styles.active]: resolvedMedia.length > 0 && resolvedMedia[current].type === "image" })} />
        </div>
    );
}